import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { desktop, laptop, tabletL, tabletS, mobile } from '@/utils/media'
import { mq } from '@/utils/helpers'
import Section from '@/components/common/Section'
import Content from '@/components/common/Content'

const EntryBlock = ({ theme, heading, html, ...other }) => (
  <Root {...other}>
    <Section
      subtitle={heading.sub}
      title={heading.main}
      titleProps={{
        variant: 'h3'
      }}
      subTitleProps={{
        lang: 'en'
      }}
    >
      <Main theme={theme}>
        <Content html={html} modifier="small"/>
      </Main>
    </Section>
  </Root>
)

const Root = styled.div``

const Main = styled.div`
  background-color: ${props => props.theme.scale[800]};
  @media ${mq.and(desktop, laptop, tabletL)} {
    padding: 80px;
  }
  @media ${mq.and(tabletS)} {
    padding: 40px 24px;
  }
  @media ${mq.and(mobile)} {
    padding: 24px 16px;
  }
`

export default ThemeConsumer(EntryBlock)
